import { useMemo } from 'react';
import {} from '../../models';
import { useFeatureSettingsQuery } from '../useFeatureSettingsQuery';
export const useFeatureSetting = (featureSettingName, defaultValue = null) => {
    const { data } = useFeatureSettingsQuery();
    return useMemo(() => {
        return data?.[featureSettingName] ?? defaultValue;
    }, [data, featureSettingName, defaultValue]);
};
